import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { BrandingClient, BrandingStylesheetModel } from './tvp-client';

@Injectable({
  providedIn: 'root',
})
export class BrandingService {
  private identifier: string | null | undefined;
  private isLoaded = false;
  private brandingSubject = new ReplaySubject<BrandingStylesheetModel>();
  readonly branding$ = this.brandingSubject.asObservable();

  constructor(private readonly brandingClient: BrandingClient) {}

  get brandingIdentifier(): string | null | undefined {
    return this.identifier;
  }

  load(brandingIdentifier: string | null): void {
    if (this.isLoaded) {
      return;
    }
    this.isLoaded = true;

    if (brandingIdentifier) {
      this.identifier = brandingIdentifier;
    }

    this.brandingClient.getBranding().subscribe((x) => {
      if (x?.branding?.brandingIdentifier) {
        this.identifier = x.branding.brandingIdentifier;
      }

      this.brandingSubject.next(x);
    });
  }
}
